import React from "react";
import Input from "../../../../../Components/Input";
import Loader from "../../../../../Components/Loader";
import MobileInput from "../../../../../Components/MobileInput";
import SmsConfigurationController from "../../../../Controllers/AdminScreens/Configuration/ConfigurationCenter/SmsConfigurationController";
import LoadingSkeleton from "../../../../../Components/LoadingSkeleton";

const SmsConfigurationScreen = ({ data, loading, error, onRefresh }) => {
    const {
        entityId,
        setEntityId,
        mobileNo,
        setMobileNo,
        countryCode,
        setCountryCode,
        saveLoading,
        saveError,
        success,
        saveSmsConfig,
        entityIdError,
        setEntityIdError,
        handleCancel,
        mobileNoError,
        setMobileNoError,
    } = SmsConfigurationController(data, loading, error, onRefresh)

    return (
        <div className='basic-info-container' >
            <h3 className="tasksScreen-tasks-title" style={{ paddingBottom: 20, fontFamily: 'Roboto Slab' }}>SMS</h3>
            {loading ? (
                <div style={{ display: 'flex', gap: '80px' }}>
                    <div>
                        <label style={styles.label}>{'Entity Id'}</label>
                        <div style={{ marginTop: 10 }}>
                            <LoadingSkeleton width="150%" height="15px" />
                        </div>
                    </div>
                    <div>
                        <label style={styles.label}>{'Mobile No.'}</label>
                        <div style={{ marginTop: 10 }}>
                            <LoadingSkeleton width="150%" height="15px" />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="tasksScreen-filters" style={{ display: 'flex' }}>
                    <Input
                        label="Entity Id"
                        placeholder="Enter Entity Id"
                        value={entityId}
                        onChange={(e) => { setEntityId(e.target.value); setEntityIdError('') }}
                        errorMessage={entityIdError}
                        searchBoxWidth={220}
                    />
                    <Input
                        label="Mobile No."
                        placeholder="Enter Mobile Number"
                        value={mobileNo}
                        onChange={(e) => { setMobileNo(e.target.value); setMobileNoError('') }}
                        inputType='number'
                        maxLength={10}
                        errorMessage={mobileNoError}
                        searchBoxWidth={220}
                    />
                    {/* <MobileInput
                    label="Mobile No."
                    countryCode={countryCode}
                    mobileNumber={mobileNo}
                    onCountryChange={setCountryCode}
                    onMobileChange={setMobileNo}
                    placeholder="Enter Mobile Number"
                    countries={[
                        { code: "IN", dialCode: "+91" },
                        { code: "US", dialCode: "+1" },
                        { code: "UK", dialCode: "+44" },
                    ]}
                /> */}
                </div>
            )}
            <div className="button-container" style={{ marginTop: '25px' }} >
                {saveError && <div className="list-error-msg" style={{ padding: 0 }}> {saveError}</div>}
                {success && <div className="list-success-msg" style={{ padding: 0 }}> {success}</div>}
            </div>
            <div className="button-container" style={{ marginBottom: '30px', }} >
                <button className="add-client-button" style={{ marginRight: '8px', paddingLeft: '30px', paddingRight: '30px', opacity: saveLoading || loading ? 0.5 : 1 }} onClick={saveSmsConfig} disabled={saveLoading || loading}>
                    {(saveLoading || loading) &&
                        <span style={{ paddingRight: 5 }} ><Loader loading={saveLoading || loading} color={'var(--background-color)'} size="small" /> </span>
                    }{data ? "Update" : "Add"}</button>
                <button className="cancel-button" onClick={handleCancel}>Cancel</button>
            </div>
        </div>
    )

}

export default SmsConfigurationScreen;

const styles = {
    label: {
        fontSize: '12px',
        color: '#343C44',
        fontWeight: 400,
        fontFamily: 'Roboto'
    },
};
